import Dashboard from './dashboard';
import Users from './users';

export default {
	Dashboard,
	Users
}
